import { Chip, ChipProps, styled } from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";

import { MissionIncidentDisplayStatus } from "src/graphql-next/generated/types";

interface Props extends ChipProps {
  status: MissionIncidentDisplayStatus;
}

const StyledChip = styled(Chip)<{ status: MissionIncidentDisplayStatus }>`
  background-color: ${(props) => props.theme.palette.missionIncident.status[props.status]};
  color: ${(props) => props.theme.palette.common.white};
  span {
    font-weight: bold;
  }
`;

export const ChipMissionIncident = ({ status, ...chipProps }: Props) => {
  const { t } = useTranslation();

  const label: Record<MissionIncidentDisplayStatus, string> = {
    [MissionIncidentDisplayStatus.RequestTransmitted]: t("Demande de devis transmise"),
    [MissionIncidentDisplayStatus.InterventionScheduled]: t("En attente d’intervention"),
    [MissionIncidentDisplayStatus.Completed]: t("Terminée"),
  };

  return <StyledChip status={status} label={label[status]} {...chipProps} />;
};
